// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__lTNj2","content":"styles_content__w42xq","image":"styles_image__ANdna","texts":"styles_texts__qqlYX","erid":"styles_erid__7j3qK"};